import * as React from 'react'
import { ChevronDown } from 'lucide-react'

import { cn } from '@/lib/utils'
import { CONTROL_CLASS, useFieldProps } from './form-field'

/**
 * The select of the platform (spec-64-u2, U-150): the browser's own `<select>` (keyboard,
 * mobile pickers and form posts keep working), drawn like `Input` with one chevron.
 * `className` sets the width of the wrapper; `selectClassName` reaches the select itself.
 */
function NativeSelect({
  className,
  selectClassName,
  children,
  ...props
}: React.ComponentProps<'select'> & { selectClassName?: string }) {
  const fieldProps = useFieldProps(props)
  return (
    <div data-slot="native-select" className={cn('relative w-full min-w-0', className)}>
      <select
        className={cn(CONTROL_CLASS, 'appearance-none pr-8', selectClassName)}
        {...fieldProps}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-muted-foreground"
      />
    </div>
  )
}

export { NativeSelect }
